// src/components/GlobalErrorBoundary.js
import React from 'react';
import { ErrorBoundary } from 'react-error-boundary';
import ErrorFallback from './ErrorFallback';

/**
 * GlobalErrorBoundary - A component that catches errors in its child component tree
 * and displays a fallback UI instead of crashing the app
 */
const GlobalErrorBoundary = ({ children }) => {
  const handleError = (error, info) => {
    // Log error to console
    console.error('Global error caught by error boundary:', error);
    console.error('Component stack:', info.componentStack);

    // Here you could send error to a logging service
    // Example: logErrorToService(error, info);
  };

  return (
    <ErrorBoundary
      FallbackComponent={ErrorFallback}
      onError={handleError}
      onReset={() => {
        // Reset the state of your app here when user clicks "Try Again" button
        window.location.href = '/';
      }}
    >
      {children}
    </ErrorBoundary>
  );
};

export default GlobalErrorBoundary;